import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import Delete from "@material-ui/icons/Delete";
import React, { useEffect, useMemo } from "react";

import {
  ACTIONS,
  EMPLOYEE_GROUP_FORM,
} from "features/planner/planner.constants";

import {
  getSummarizedDataStatesFromState,
  getCurrentUserAppRolesFromState,
} from "app/app.selectors";

import {
  getEmployeeGroups,
  editEmployeeGroupOnSubmit,
  initializeEditEmployeeGroup,
  createEmployeeGroupOnSubmit,
  deleteEmployeeGroup,
} from "features/planner/planner.actions";

import CrudBasePage from "app/components/CrudBasePage";
import { hasRequiredAccessLevel } from "utils/app.util";
import { getAccessControlButton } from "utils/component.util";
import { getEmployeeGroupsFromState } from "features/planner/planner.selectors";
import EmployeeGroupForm from "features/planner/settings/employeeGroups/EmployeeGroupForm";

import { getModifiedByValue } from "utils/app.util";

const SettingsEmployeeGroupsContainer = ({
  Icon,
  dataState,
  breadcrumb,
  dispatchOnLoad,
  employeeGroups,
  crudAccessLevel,
  currentUserAppRoles,
  dispatchDeleteEmployeeGroup,
  dispatchEditEmployeeGroupOnSubmit,
  dispatchCreateEmployeeGroupOnSubmit,
  dispatchInitializeEditEmployeeGroup,
}) => {
  useEffect(() => {
    dispatchOnLoad();
  }, [dispatchOnLoad]);

  const columns = useMemo(
    () => [
      {
        xs: true,
        title: "Name",
        getSortProperty: item => item.get("name"),
      },
      {
        xs: true,
        component: Grid,
        title: "Modified by",
        getSortProperty: item => item.get("modifiedBy"),
        getValue: getModifiedByValue,
      },
    ],
    [],
  );

  const actions = useMemo(
    () => [
      getAccessControlButton(
        crudAccessLevel.delete,
        dispatchDeleteEmployeeGroup,
        <Delete fontSize="small" />,
        "Delete",
      ),
    ],
    [crudAccessLevel, dispatchDeleteEmployeeGroup],
  );

  return (
    <CrudBasePage
      Icon={Icon}
      title={breadcrumb}
      displayAddButton={hasRequiredAccessLevel(
        crudAccessLevel.create,
        currentUserAppRoles,
      )}
      displaySearchField
      dataState={dataState}
      items={employeeGroups}
      SortableListProps={{
        onRowClick: hasRequiredAccessLevel(
          crudAccessLevel.edit,
          currentUserAppRoles,
        )
          ? dispatchInitializeEditEmployeeGroup
          : null,
        actions: actions,
        columns: columns,
        getKey: x => x.get("id"),
      }}
      CreateModalProps={{
        submitText: "Add",
        title: "Add Employee Group",
        onSubmit: dispatchCreateEmployeeGroupOnSubmit,
      }}
      CreateEntityFormComponent={EmployeeGroupForm}
      createEntityForm={{
        form: EMPLOYEE_GROUP_FORM.ID,
      }}
      EditModalProps={{
        submitText: "Save",
        title: "Edit Employee Group",
        onSubmit: dispatchEditEmployeeGroupOnSubmit,
        formTitleField: EMPLOYEE_GROUP_FORM.NAME,
      }}
      EditEntityFormComponent={EmployeeGroupForm}
      editEntityForm={{
        form: EMPLOYEE_GROUP_FORM.ID,
      }}
    />
  );
};

export default compose(
  connect(
    state => ({
      currentUserAppRoles: getCurrentUserAppRolesFromState(state),
      dataState: getSummarizedDataStatesFromState(
        state,
        ACTIONS.GET_EMPLOYEE_GROUPS,
        ACTIONS.DELETE_EMPLOYEE_GROUP,
      ),
      employeeGroups: getEmployeeGroupsFromState(state),
    }),
    {
      dispatchOnLoad: getEmployeeGroups,
      dispatchCreateEmployeeGroupOnSubmit: createEmployeeGroupOnSubmit,
      dispatchDeleteEmployeeGroup: deleteEmployeeGroup,
      dispatchEditEmployeeGroupOnSubmit: editEmployeeGroupOnSubmit,
      dispatchInitializeEditEmployeeGroup: initializeEditEmployeeGroup,
    },
  ),
)(SettingsEmployeeGroupsContainer);
